<div class="room-select-message">
    <!-- <img src="assets/images/picture.svg" alt="wa" style="height: 442px; width: 60%;"> -->
</div>